import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type CountriesRequest = CommonTableRequest;
export type FlagsRequest = CommonTableRequest;

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface Country {
    id: number;
    countryCode: string;
    country: string;
    isoAlpha2: string;
    isoAlpha3: string;
    nationality: string;
    isActive: boolean;
    builtIn: boolean;
    isActiveForShore: boolean;
    isActiveForCrew: boolean;
    isActiveForFlag: boolean;
    createdAtUTC: string;
}

export interface CountriesResponse {
    data: Country[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface Flag {
    id: number;
    flagJurisdiction: string;
    flagCode: string;
    registryName: string;
    isActive: boolean;
    builtIn: boolean;
    createdAtUTC: string;
}

export interface FlagsResponse {
    data: Flag[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface UpdateFlagRequest {
    isActive: boolean;
}

export interface UpdateCountryRequest {
    isActive: boolean;
    isActiveForShore: boolean;
    isActiveForCrew: boolean;
    isActiveForFlag: boolean;
}

export const getApiFlags = (clientId: number, tenantAlias: string, payload: FlagsRequest): Promise<FlagsResponse> =>
    httpApi
        .post<FlagsResponse>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/flags/search`, payload)
        .then(({ data }) => data);

export const updateApiFlag = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateFlagRequest,
): Promise<Flag> =>
    httpApi
        .put<Flag>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/flags/${id}`, payload)
        .then(({ data }) => data);

export const getApiCountries = (
    clientId: number,
    tenantAlias: string,
    payload: CountriesRequest,
): Promise<CountriesResponse> =>
    httpApi
        .post<CountriesResponse>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/countries/search`, payload)
        .then(({ data }) => data);

export const updateApiCountry = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateCountryRequest,
): Promise<Country> =>
    httpApi
        .put<Country>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/countries/${id}`, payload)
        .then(({ data }) => data);
